import React from 'react'
import { Dialog, DialogTitle, DialogContent, DialogActions, Typography, IconButton } from '@mui/material'
import { makeStyles } from '@mui/styles'
import Controls from "./control";
import NotListedLocationIcon from '@mui/icons-material/NotListedLocation';


const useStyles = makeStyles(theme => ({
    dialog: {
        padding: theme && theme.spacing ? theme.spacing(2) : '16px',
        position: 'absolute',
        top: theme && theme.spacing ? theme.spacing(5) : '40px'
    },
    dialogTitle: {
        textAlign: 'center'
    },
    dialogContent: {
        textAlign: 'center'
    },
    dialogAction: {
        justifyContent: 'center'
    },
    titleIcon: {
        backgroundColor: theme && theme.palette && theme.palette.light ? theme.palette.light : 'inherit',
        color: theme && theme.palette && theme.palette.secondary ? theme.palette.secondary.main : 'inherit',
        '&:hover': {
            backgroundColor: theme && theme.palette && theme.palette.secondary ? theme.palette.secondary.light : 'inherit',
            cursor: 'default'
        },
        '& .MuiSvgIcon-root': {
            fontSize: '8rem',
        }
    }
}))

export default function ConfirmDialog(props) {

    const { confirmDialog, setConfirmDialog } = props;
    const classes = useStyles()

    return (
        <Dialog open={confirmDialog.isOpen} classes={{ paper: classes.dialog }}>
            <DialogTitle className={classes.dialogTitle}>
                <IconButton disableRipple className={classes.titleIcon}>
                    <NotListedLocationIcon />
                </IconButton>
            </DialogTitle>
            <DialogContent className={classes.dialogContent}>
                <Typography variant="h6">
                    {confirmDialog.title}
                </Typography>
                <Typography variant="subtitle2">
                    {confirmDialog.subTitle}
                </Typography>
            </DialogContent>
            <DialogActions className={classes.dialogAction}>
                <Controls.Button
                    text="Skip"
                    color="default"
                    onClick={() => setConfirmDialog({ ...confirmDialog, isOpen: false })} />
                <Controls.Button
                    text="Sure"
                    color="secondary"
                    onClick={confirmDialog.onConfirm} />
            </DialogActions>
        </Dialog>
    )
}